import { useEffect, useRef, useState } from 'react'
import { cn } from '@/lib/utils'

/** Dropdown simples acionado por um botão (trigger). */
export function Dropdown({ trigger, children, align = 'right' }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    function onClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [])

  return (
    <div className="relative" ref={ref}>
      <div onClick={() => setOpen((o) => !o)}>{trigger}</div>
      {open && (
        <div
          className={cn(
            'absolute z-50 mt-1 min-w-[220px] rounded-md border border-border bg-popover shadow-lg py-1',
            align === 'right' ? 'right-0' : 'left-0'
          )}
          onClick={() => setOpen(false)}
        >
          {children}
        </div>
      )}
    </div>
  )
}

export function DropdownItem({ className, ...props }) {
  return (
    <button
      className={cn('w-full text-left px-3 py-2 text-sm hover:bg-accent/60 flex items-center gap-2', className)}
      {...props}
    />
  )
}
